"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownMenuSizes = void 0;
exports.dropdownMenuSizes = {
    xsmall: {
        width: "200px",
    },
    small: {
        width: "300px",
    },
    medium: {
        width: "400px",
    },
};
//# sourceMappingURL=DropdownMenu.constants.js.map